<template>

    <div class="nr_container_content catalog_page__filter mb-160 ">

        <div class="products__links d-none">
            <a
                    href="/upload/iblock/29d/x4vfk0jhi93gksid8bmtaoctvuoru9nq/KatalogNOVAROLL2021.pdf"
                    download="" class="d-block border-0 py-0 mt-4 color-dark"
            >
                <img src="/upload/pad_img.svg" alt="" class="pr-3">
                <span class="text-decoration-underline">Скачать каталог NOVAROLL Транспортная упаковка</span>
            </a>
            <a href="/upload/iblock/a50/h99vzn2amkito52um1qk0sdmogxqjdlp/catalog_unibob.pdf" target="_blank"
               class="d-block border-0 py-0 mt-4 color-dark">
                <img src="/upload/pad_img.svg" alt="" class="pr-3">
                <span class="text-decoration-underline">Каталог UNIBOB</span>
            </a>
        </div>

        <div class=" wow fadeUp" :class="emptyfilter ? 'row--empty' : 'row ' ">
            <div class="" :class="emptyfilter ? 'd-none' : ' ' ">
                <div class="catalog_page__filter_items">

                    <div
                            class="filter_item mb-6 "
                            v-for="(list, name, indexCat) in category_lists"
                    >
                        <!--                    <div class="filter_item" v-for="(list, name, indexCat) in category_lists">-->
                        <div class="filter_item__title">{{ list }}</div>
                        <div class="filter_item__boxes"
                             :class="showMore[name] ? 'filter_item--expanded' : 'filter_item--collapsed'">
                            <transition-group name="fade-list" tag="div" class="filter_item__inner">
                                <div class="filter_item__sel d-flex"
                                     v-for="(checkbox, index) of visibleCheckboxes[name]"
                                     :key="checkbox.value">

                                    <v-checkbox
                                            v-model="filter_type_checkbox_checked"
                                            :value="checkbox.value"
                                            color="red darken-3"
                                            hide-details
                                            @change="change_filter(checkbox, index)"
                                    >
                                        <template v-slot:label>
                                            <div>
                                                {{ checkbox.label }}
                                                <button class="filter_item__info " v-if="checkbox.prompt.length > 0">
                                                    <img src="/local/templates/international/img/fi_info.svg"
                                                         class="d-inline-block">
                                                    <span v-html="checkbox.prompt"></span>
                                                </button>
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </div>
                            </transition-group>
                        </div>


                        <button v-if="numberBoxes(name)" @click="toggleShowMore(name)" class="show-more_btn">
                            <span v-if="!showMore[name]" class="btn-text-fade">Показать еще
                                <svg class="show-more_btn--svg" width="13" height="6" viewBox="0 0 13 6" fill="none"
                                     xmlns="http://w3.org">
                                    <path d="M0.5 0L6.5 6L12.5 0L0.5 0Z" fill="#FA4237"/>
                                </svg>
                            </span>
                            <span v-else class="btn-text-fade">Скрыть
                                <svg width="13" height="6" viewBox="0 0 13 6" fill="none" xmlns="http://w3.org">
                                    <g clip-path="url(#clip0_2489_5811)">
                                        <path d="M12.5 6L6.5 -5.24537e-07L0.5 6L12.5 6Z" fill="#FA4237"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2489_5811"><rect width="13" height="6" fill="white"
                                                                             transform="translate(13 6) rotate(-180)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="">
                <div class="catalog_page__filter_contents">

                    <div class="row filter_contents__item_row position-relative"
                         v-if="Object.keys(items_checked).length <= 0">
                        <div class="noResults  w-100 text-center">
                            <div class="noResults__title">Нет результатов</div>
                            <button class="btn_red reset_filter" @click="filterReset">Сбросить фильтр</button>
                        </div>
                    </div>

                    <!--Если заголовки захотят вернуть <div class="row filter_contents__item_row position-relative" v-for="(list, name, indexItems) in itemsLists">-->
                    <div class=" filter_contents__item_row position-relative">

                        <!--Если заголовки захотят вернуть <div class="filter_contents__title w-100">{{ list }}</div> -->

                        <div class="filter_contents__item mb-0 market  position-relative"
                             v-for="(item, index) of items_checked">
                            <!--Если заголовки захотят вернуть v-for="(item, index) of items_checked" v-if="name == item.type">-->

                            <div class="bar_item__content h-100">
                                <div class="item_plain h-100">
                                    <div class="d-flex h-100 item_plain__content item_polls flex-column">
                                        <div class="market__img d-flex justify-content-center">
                                            <img :src="item.img">
                                        </div>
                                        <div class="w-100 h-100 justify-content-between flex-column d-flex item_plain__descr">

                                            <div class="item_plain__title flex-grow-1">
                                                {{ item.name }}
                                            </div>

                                            <!--                                            <div class="d-flex align-items-center market__btn my-0 mt-4">-->
                                            <!--                                                <a :href="item.url" class="btn btn_red market_redeem ">Подробнее</a>-->
                                            <!--                                            </div>-->

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <a :href="item.url" class="w-100 position-absolute h-100 l-0 t-0 zi-1"></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        items: String | Number | Boolean | Object | Array,
        filter_type_checkbox: String | Number | Boolean | Object | Array,
        category_lists: String | Number | Boolean | Object | Array,
        emptyfilter: Boolean,

        //itemsLists: String | Number | Boolean | Object | Array, Если заголовки захотят вернуть
    },

    computed: {
        filter_type_checkbox_data() {
            // Преобразуем объект в массив значений (если это объект) или используем как есть (если это массив)
            if (!this.filter_type_checkbox) {
                return [];
            }
            return Array.isArray(this.filter_type_checkbox)
                ? this.filter_type_checkbox
                : Object.values(this.filter_type_checkbox);
        },
        visibleCheckboxes() {
            const result = {};
            for (const name in this.category_lists) {
                const filtered = this.filter_type_checkbox_data.filter(
                    checkbox => checkbox && checkbox.catType === name
                );
                result[name] = this.showMore[name] ? filtered : filtered.slice(0, 5);
            }
            return result;
        }
    },
    data() {
        return {
            showMore: {},
            filter_type_checkbox_checked: [],
            items_checked: {},

            // itemsLists: { // Если заголовки захотят вернуть
            //   "Rulonnaia-upakovka": "Рулонная упаковка",
            //   "Paketnaia-produktciia": "Пакетная продукция",
            // },

            /* category_lists: {
              "category": "Категории",
              "applicationArea": "Область применения",
              "additionalProperties": "Дополнительные свойства",
            }, */

            /* filter_type_checkbox: [

              {
                catType: 'category', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Rulonnaia-upakovka",
                label: "Рулонная упаковка",
                prompt: "",
              },
              {
                catType: 'category', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Paketnaia-produktciia",
                label: "Пакетная продукция",
                prompt: "",
              },

              // applicationArea
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Chai-kofe",
                label: "Чай и кофе",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Snekovaia-produktciia",
                label: "Снековая продукция",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Sahar-soli-makarony-krupy",
                label: "Сахар, соли, макароны, крупы",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Sousy-maionez",
                label: "Соусы и майонез",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Suhie-vlazhnye-korma",
                label: "Сухие и влажные корма",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Konditerskie-izdeliia",
                label: "Кондитерские изделия",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Ovoshchi-s-perforatciei",
                label: "Овощи с перфорацией",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Zelen-salatov-fresh",
                label: "Зелень салатов фреш",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Spetcii-pripravy",
                label: "Специи и приправы",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Piure-doipaki",
                label: "Пюре и дойпаки",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Molochnaia-produktciia-morozhennoe",
                label: "Молочная продукция, мороженное",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Zamorozhennye-polufabrikaty",
                label: "Замороженные полуфабрикаты",
                prompt: "",
              },
              {
                catType: 'applicationArea', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Svezhee-miaso-polufabrikaty",
                label: "Свежее мясо, полуфабрикаты",
                prompt: "",
              },

              // applicationArea end


              // additionalProperties
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Makroperforatciia",
                label: "Макроперфорация",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст <a href='#'>Можно и ссылку</a> и <strong>Заголовок</strong>",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Anti-fog-effekt",
                label: "Анти-фог эффект",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Peel-Pil-effekt",
                label: "Peel (Пил) эффект",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Re-clouse-reclouz-effekt",
                label: "Re-clouse (реклоуз) эффект",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Vysokii-barer",
                label: "Высокий барьер",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Srednii-barer",
                label: "Средний барьер",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Metallizirovannaia",
                label: "Металлизированная",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Demetallizirovannaia",
                label: "Деметаллизированная",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Matovaia",
                label: "Матовая",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Zhemchuzhnaia",
                label: "Жемчужная",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Belaia",
                label: "Белая",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Evroslot",
                label: "Еврослот",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Nasechka",
                label: "Насечка",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Zip-lock-zastezhka",
                label: "Zip-lock застежка",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Dozator",
                label: "Дозатор",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Kofeinyi-clapan-degazatciia",
                label: "Кофейный клапан, дегазация",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Prozrachnoe-okno",
                label: "Прозрачное окно",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Prorubnaia-ruchka",
                label: "Прорубная ручка",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Vozmozhnost-sterilizatcii",
                label: "Возможность стерилизации",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              {
                catType: 'additionalProperties', // объект для выделения заголовков в цикле, в логике фильтрации не участвует
                value: "Laminatciia-s-aliuminievoi-folgoi",
                label: "Ламинация с алюминиевой фольгой",
                prompt: "Какой-то текст с подсказкой. Текст текст текст текст текст текст текст текст текст текст текст текст текст текст ",
              },
              // additionalProperties end
            ],
            */

            /*
            items: [
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Пленки для упаковки свежих овощей и салатов",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 9.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Пленки для запайки лотков и стаканов",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 8.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Пленки для барьерной упаковки",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 7.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Пленка для упаковки лекарств и медицинских изделий",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 6.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Круговая БОПП этикетка",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 5.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Пленки для ламинации",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 4.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Покрывные пленки для вакуумной упаковки",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 3.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "БОПП пленки различного назначения",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 2.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Пленки для замороженной продукции",
                img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 1.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Пленки для упаковки косметических изделий, влажных салфеток, туалетной бумаги",
                img: "/upload/filter_img/Пленки-для-упаковки-свежих-овощей-и-салатов 8.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Rulonnaia-upakovka", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Пленки для упаковки в саше ",
                img: "/upload/filter_img/Пленки-для-упаковки-свежих-овощей-и-салатов 7.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Chai-kofe Snekovaia-produktciia", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Для чая, кофе",
                img: "/upload/filter_img/Пленки-для-упаковки-свежих-овощей-и-салатов 6.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Paketnaia-produktciia", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Твист-пленки для упаковки конфет и леденцов",
                img: "/upload/filter_img/Пленки-для-упаковки-свежих-овощей-и-салатов 5.png",
                url: "#",
                catLabel: 'Рулонная упаковка',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Paketnaia-produktciia", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Термоусадочный пакет",
                img: "/upload/filter_img/Пленки-для-упаковки-свежих-овощей-и-салатов 4.png",
                url: "#",
                catLabel: 'Пакетная продукция',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Paketnaia-produktciia", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Дой-пак пакет",
                img: "/upload/filter_img/Пленки-для-упаковки-свежих-овощей-и-салатов 3.png",
                url: "#",
                catLabel: 'Пакетная продукция',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Paketnaia-produktciia", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Фальцованный пакет",
                img: "/upload/filter_img/Пленки-для-упаковки-свежих-овощей-и-салатов 2.png",
                url: "#",
                catLabel: 'Пакетная продукция',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
              {
                type: "Paketnaia-produktciia", // значение поля value у фильтра. Можно указать через пробел, если элемент принадлежит нескольким позициям.
                name: "Трехшовный пакет",
                img: "/upload/filter_img/Пленки-для-упаковки-свежих-овощей-и-салатов 1.png",
                url: "#",
                catLabel: 'Пакетная продукция',
                id: "", // По необходимости Артемий, в фильтрации не учавствует
              },
            ],
             */

            // loader: true, // плавающий прелоудер

        };
    },
    methods: {
        toggleShowMore(name) {
            this.$set
                ? this.$set(this.showMore, name, !this.showMore[name])
                : (this.showMore = {...this.showMore, [name]: !this.showMore[name]});
        },
        change_filter(checkbox, index) {
            // берем массив выбранных значений > все выбранные значения ищем в коллекции items > создаем ассоциативный объект из выбранных значений, где ключ - уникальный id
            var items_checked = this.items_checked = {};


            var arrayData = this.items;
            var checked = this.filter_type_checkbox_checked;


            if (checked.length > 0) {

                for (let index in checked) {

                    // console.log(checked[index]);

                    for (let arrayData_index in arrayData) {
                        // console.log(arrayData_index);

                        var regexp = new RegExp(`${checked[index]}`, 'i');

                        if (regexp.test(arrayData[arrayData_index].type)) {
                            Object.assign(this.items_checked, {[arrayData_index]: arrayData[arrayData_index]}); // создаем асcоцианивный объект, чтобы не было дублей
                        }

                    }

                }


            } else {
                this.items_checked = this.items;
            }

            // this.$nextTick(function () {
            var lengthChecked = Object.keys(this.items_checked);
            if (lengthChecked.length < 12) {

                if (checkbox.value == "Chipsy-sukhariki" || lengthChecked.length < 3) {

                    setTimeout(() => {
                        $('html, body').animate({
                            scrollTop: $(".filter_contents__item:last-of-type").offset().top - 200 // id объекта к которому приезжаем
                        }, 1000);
                    }, 500)
                }
            }
            // });

        },
        filterReset() {
            this.items_checked = this.items;
            this.filter_type_checkbox_checked = [];

        },
        numberBoxes(name) {
            try {
                // Проверяем, что данные есть
                if (!this.filter_type_checkbox_data || !Array.isArray(this.filter_type_checkbox_data)) {
                    return false;
                }

                // Подсчитываем количество чекбоксов для конкретного блока (категории)
                // где catType совпадает с name (ключом из category_lists)
                const count = this.filter_type_checkbox_data.filter(
                    checkbox => checkbox && checkbox.catType === name
                ).length;

                // Отладка
                console.log(`numberBoxes для блока "${name}": найдено ${count} чекбоксов, показывать кнопку: ${count > 5}`);

                // Если количество больше 5, показываем кнопку, иначе скрываем
                return count > 5;
            } catch (error) {
                console.error('Error in numberBoxes:', error);
                return false;
            }
        },
    },
    created() {
        this.items_checked = this.items;
    },


};
</script>
<style lang="scss">
@import "../../theme/_variable.scss";

.loadAnimation {
  & .preloader {
    background: white;
    position: absolute;
    z-index: 2;
  }
}

.catalog_page__filter {

  .fade-list-enter-active, .fade-list-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .fade-list-enter, .fade-list-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }

  .fade-list-move {
    transition: transform 0.3s ease-in-out;
  }

  .filter_item__boxes, .filter_item__inner {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  & .row {
    display: grid;
    grid-template-columns: 350px 3fr;
    margin: 0;

    @media (max-width: 1100px) {
      grid-template-columns: 300px 1fr;
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }

    &--empty {
      margin: 0;
    }
  }

  & .market__img {
    & img {
      height: 150px;
      max-width: 200px;
      margin-top: 10px;
      object-fit: cover;
    }
  }

  .filter_contents__item_row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px;

    @media (max-width: 1100px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 550px) {
      grid-template-columns: 1fr;
    }

    & .noResults {
      margin-top: 70px;

      & .noResults__title {
        font-family: $font-Museo700;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 100%;
        color: #282828;

      }

      & .reset_filter {
        padding: 10px 30px;
        margin-top: 35px;
      }
    }


    & .filter_contents__title {
      font-family: $font-Museo700;
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 100%;
      color: #282828;
      margin-bottom: 40px;
    }

  }

  & .filter_contents__item {
    -webkit-transition: all ease-in-out .3s;
    -o-transition: all ease-in-out .3s;
    transition: all ease-in-out .3s;

    &:focus,
    &:hover {

      & .item_plain__title {
        color: #FA4237;
      }

      & .bar_item__content {
        border-color: #FF4237;
      }
    }


    & .item_plain__descr {
      padding: 24px;
    }

    & .bar_item__content {
      background: #fff;
      border: 1px solid #E8E8E8;
      border-radius: 20px;
      transition: all 0.2s ease;
    }

    & .market_redeem {
      padding: 10px 32px;
      font-family: $font-Museo700;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 100%;
      color: #FFFFFF;
    }

    & .item_plain__title {
      font-family: 'MuseoSansCyrl-500';
      font-weight: 400;
      font-style: 500;
      font-size: 24px;
      leading-trim: NONE;
      line-height: 28px;
      letter-spacing: 0px;
      vertical-align: middle;
      color: #212424;
      margin: 0;
      transition: all 0.2s ease;
      display: flex;
      align-items: baseline;
    }
  }

  & .catalog_page__filter_items {
    margin-top: 15px;
    margin-right: 10px;


    & .v-input--selection-controls {
      margin-top: 5px;
      padding-top: 4px;
    }

    button.filter_item__info {
      margin-bottom: 2px;
      position: relative;

      &:hover,
      &.active {
        & span {
          height: 100%;
          visibility: visible;
        }
      }

      & span {
        margin-left: 18px;
        top: 0px;
        left: 0;
        position: absolute;
        z-index: 2;
        height: 0px;
        width: 250px;
        visibility: hidden;
        display: table;
        background: #fff;
        padding: 10px 10px;
        box-shadow: 0px 4px 20px 4px rgba(0, 0, 0, 0.04);
        border-radius: 15px;
        font-size: 15px;
        text-align: left;
      }
    }
  }


  & .filter_item__title {
    font-family: 'RobotoRegular';
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #121315;
    margin-bottom: 15px;
  }

  & .filter_item__sel {
    min-width: 235px;
  }


  & .v-input {
    & .v-label {
      font-family: 'RobotoRegular';
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0px;
      color: #121315;
      margin-bottom: 0;
    }
  }

  & .filter_item__boxes {
    margin-bottom: 10px;
  }

  & .filter_item--expanded {
    height: auto;
  }

  & .filter_item__boxes {
    padding-left: 10px;
  }

  & .filter_item--collapsed {
    height: 100%;
    overflow: hidden;
    transition: height 0.3s ease;

  }

  & .show-more_btn {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #FA4237;
    min-width: 140px;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
  }

  .btn-text-fade {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    animation: fadeInTextOnly 0.2s ease-in-out forwards;
  }

  @keyframes fadeInTextOnly {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  & .v-input--selection-controls__input {
    & .v-icon.v-icon {

    }
  }
}

</style>
